import { AnalysisType } from 'projects/dop-ordering/src/public-api';
import { LinkedSpecification } from './linked-specification.model';

export class SampleInvoiceableItems {
    id: number;
    testCode: string;
    packageCode: string;
    customerPackageCode: string;
    subGroupCode: string;
    quotationLineCode: string;
    specifications: LinkedSpecification[];
    comment?: string;
    salesCatagloueCode: string;
    testBundleCode: string;
    monographCode: string;
    compendiumCode: string;
    preparationTestCodes?: string[];
    isMrt: boolean;
    executionNumber?: number;
}

export function GetScInvoiceableItemType(item: SampleInvoiceableItems): AnalysisType {
    if (item.salesCatagloueCode) {
        if (item.testBundleCode) {
            return AnalysisType.SalesCatalogueTestBundle;
        } else if (item.packageCode) {
            return AnalysisType.SalesCataloguePackage;
        } else if (item.testCode) {
            return AnalysisType.SalesCatalogueTest;
        }
    }
}


